var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SubjectStatusSelect',{attrs:{"hide-details":"","value":_vm.value,"multiple":_vm.multiple,"exclude":_vm.exclude,"return-object":_vm.returnObject},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }